/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateExternalOAuthServerRequestBody = {
  /**
   * Exact HTTPS issuer to set for provider-hosted discovery. Speakeasy strictly discovers and verifies it before the atomic update. Supply exactly one of authorization_server_issuer and metadata; clients may need to register or authenticate again after a mode change.
   */
  authorizationServerIssuer?: string | undefined;
  /**
   * JSON object metadata to restore Speakeasy-hosted compatibility mode. Supply exactly one of metadata and authorization_server_issuer.
   */
  metadata?: any | undefined;
};

/** @internal */
export type UpdateExternalOAuthServerRequestBody$Outbound = {
  authorization_server_issuer?: string | undefined;
  metadata?: any | undefined;
};

/** @internal */
export const UpdateExternalOAuthServerRequestBody$outboundSchema: z.ZodMiniType<
  UpdateExternalOAuthServerRequestBody$Outbound,
  UpdateExternalOAuthServerRequestBody
> = z.pipe(
  z.object({
    authorizationServerIssuer: z.optional(z.string()),
    metadata: z.optional(z.any()),
  }),
  z.transform((v) => {
    return remap$(v, {
      authorizationServerIssuer: "authorization_server_issuer",
    });
  }),
);

export function updateExternalOAuthServerRequestBodyToJSON(
  updateExternalOAuthServerRequestBody: UpdateExternalOAuthServerRequestBody,
): string {
  return JSON.stringify(
    UpdateExternalOAuthServerRequestBody$outboundSchema.parse(
      updateExternalOAuthServerRequestBody,
    ),
  );
}
